// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// import Swiper JS
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade} from 'swiper/modules';

Swiper.use([Navigation, Pagination, EffectFade]);

const hero_slider = new Swiper(".clac-006-hero-slider", {
    modules: [Navigation, Pagination, EffectFade],
    speed: 500,
    loop: true,
    effect: 'fade',
    autoplay: {
        // disableOnInteraction: true,
        // pauseOnMouseEnter: true,
        delay: 1000,
    },
    fadeEffect: {
        crossFade: true,
    },
    pagination: {
        el: ".clac-006-hero-slider__pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".clac-006-hero-slider__next",
        prevEl: ".clac-006-hero-slider__prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
    },
    on: {
        init: function (swiper) {
            swiper.params.navigation.enabled = swiper.slides.length > 1;
            swiper.params.loop = swiper.slides.length > 1
        }
    }
});

const timeline_slider = new Swiper('.js-swiper--timeline', {
  speed: 400,
  loop: true,
  autoHeight: true,
  modules: [Navigation, Pagination],
  // Pagination fraction numbers
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});

export default Swiper;